import React from 'react'

export type DropdownPropsContextValue = {
  arrowRef: unknown
  arrowStyle: React.CSSProperties | undefined
  floating: unknown
  floatingStyle: React.CSSProperties | undefined
  hasArrow: boolean
  isToggled: boolean
  middlewareData: unknown
  reference: unknown
}

export type DropdownHandlersContextValue = {
  onDismiss: () => void
  onToggle: (event: Event | React.MouseEvent<HTMLElement>) => void
}

export const DropdownPropsContext = React.createContext<
  DropdownPropsContextValue | undefined
>(undefined)
export const DropdownHandlersContext = React.createContext<
  DropdownHandlersContextValue | undefined
>(undefined)
